// Shared design tokens for the dark "deep violet" public-site redesign
// (landing page, about, services, contact, tracking, calculator).
// Neither Space Grotesk nor DM Sans cover Lao glyphs, so Noto Sans Lao is
// listed as the fallback for Lao-locale text (matches the convention already
// used in theme.js / financial pages).
export const SG = "'Space Grotesk', 'Noto Sans Lao', sans-serif";
export const BODY_FONT = "'DM Sans', 'Noto Sans Lao', sans-serif";
export const BG = "#07041A";
export const PANEL = "#0C0820";
export const TEXT = "#F8F5FF";
export const PURPLE = "#7C3AED";
export const PURPLE_HOVER = "#6D28D9";
export const PURPLE_LIGHT = "#A855F7";
export const PURPLE_LIGHTER = "#C084FC";
export const LIGHT_BAND = "#F0EAFF";

export const MAXW = 1240;

// Primary / ghost button style objects, reused across all dark public pages.
export const btnP = {
  background: PURPLE,
  color: "#fff",
  fontFamily: SG,
  fontWeight: 600,
  fontSize: 14,
  letterSpacing: ".02em",
  textTransform: "none",
  px: 3.5,
  py: 1.75,
  borderRadius: "10px",
  display: "inline-flex",
  alignItems: "center",
  gap: 0.875,
  whiteSpace: "nowrap",
  boxShadow: "none",
  transition: "all .22s",
  "&:hover": { background: PURPLE_HOVER, transform: "translateY(-2px)", boxShadow: "0 8px 28px rgba(124,58,237,.5)" },
};

export const btnG = {
  background: "transparent",
  color: TEXT,
  fontFamily: SG,
  fontWeight: 600,
  fontSize: 14,
  letterSpacing: ".02em",
  textTransform: "none",
  px: 3.5,
  py: 1.75,
  borderRadius: "10px",
  border: "1.5px solid rgba(248,245,255,.18)",
  display: "inline-flex",
  alignItems: "center",
  gap: 0.875,
  whiteSpace: "nowrap",
  transition: "all .22s",
  "&:hover": { borderColor: "rgba(168,85,247,.65)", background: "rgba(124,58,237,.1)" },
};
